// extracted by mini-css-extract-plugin
export default {"section":"Section_section__4C8jt","title":"Section_title__7bRUN","subtitle":"Section_subtitle__LOeM9","content":"Section_content__eCHr7"};